// General
import React from 'react';
import PropTypes from 'prop-types';
// Redux
import { connect } from 'react-redux';

// Translation
import { injectIntl, FormattedMessage } from 'react-intl';
import messages from '../../locale/messages';

// Animation
import { motion, AnimatePresence } from 'framer-motion';

// Icons
import { Search, X, Sparkles, MapPin } from 'lucide-react';

// Styles
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Header.css';
import cx from 'classnames';
import {
  Navbar,
} from 'react-bootstrap';

// Internal Components
import Navigation from '../Navigation';
import Logo from '../Logo';
import HeaderSearchBar from './HeaderSearchBar';
import Link from '../Link';

// External Components
import Toaster from '../Toaster';
import LoadingBar from 'react-redux-loading-bar';
import HeaderLocationSearch from './HeaderLocationSearch';

// Redux action
import { toggleOpen, toggleClose } from '../../actions/Menu/toggleControl';

import history from '../../core/history';
import DropDownMenu from '../DropDownMenu/DropDownMenu';

class Header extends React.Component {
  static propTypes = {
    borderLess: PropTypes.bool,
    showMenu: PropTypes.bool,
    toggleOpen: PropTypes.any.isRequired,
    formatMessage: PropTypes.any,
  };

  static defaultProps = {
    borderLess: false,
    showMenu: false,
    searchDisablePages: [
      '/',
      '/home'
    ]
  }

  constructor(props) {
    super(props);
    this.state = {
      searchHide: true,
      load: false,
      isOpen: false,
      mobileSearchOpen: false,
      mobileSearchQuery: '',
      isMobile: false,
      isScrolled: false, // AUTÓNOMO: estado local del scroll
    };
    this.handleMenu = this.handleMenu.bind(this);
    this.handleDisableSearchPages = this.handleDisableSearchPages.bind(this);
    this.openMenu = this.openMenu.bind(this);
    this.openClose = this.openClose.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.openMobileSearch = this.openMobileSearch.bind(this);
    this.closeMobileSearch = this.closeMobileSearch.bind(this);
    this.handleMobileSearch = this.handleMobileSearch.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    this.setState({
      load: true,
      isMobile: typeof window !== 'undefined' && window.innerWidth < 768
    });
    this.handleDisableSearchPages();

    // AUTÓNOMO: Scroll listener interno del Header
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', this.handleResize);
      window.addEventListener('scroll', this.handleScroll, { passive: true });
      // Check initial scroll position
      this.handleScroll();
    }
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.handleResize);
      window.removeEventListener('scroll', this.handleScroll);
    }
  }

  // AUTÓNOMO: El Header detecta el scroll por sí mismo
  handleScroll() {
    const threshold = 300; // Umbral de scroll
    const scrollY = window.scrollY || window.pageYOffset;
    const isScrolled = scrollY > threshold;

    if (this.state.isScrolled !== isScrolled) {
      this.setState({ isScrolled });
    }
  }

  handleResize() {
    const isMobile = window.innerWidth < 768;
    if (this.state.isMobile !== isMobile) {
      this.setState({ isMobile });
    }
  }

  openMobileSearch() {
    this.setState({ mobileSearchOpen: true });
    document.body.style.overflow = 'hidden';
  }

  closeMobileSearch() {
    this.setState({ mobileSearchOpen: false, mobileSearchQuery: '' });
    document.body.style.overflow = '';
  }

  handleMobileSearch(e) {
    e && e.preventDefault();
    const { mobileSearchQuery } = this.state;
    if (!mobileSearchQuery.trim()) return;

    // Navigate to search results
    const params = new URLSearchParams();
    params.set('address', mobileSearchQuery.trim());
    params.set('chosen', '1');

    this.closeMobileSearch();
    history.push(`/s?${params.toString()}`);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.handleDisableSearchPages();
  }

  handleMenu() {
    const { showMenu, toggleOpen, toggleClose } = this.props;
    if (showMenu) {
      toggleClose();
    } else {
      toggleOpen();
    }
  }



  handleDisableSearchPages() {
    const { searchDisablePages } = this.props;
    let location = history.location ? history.location.pathname : null;
    let searchHide = false;
    if (location && searchDisablePages.length > 0) {
      searchHide = searchDisablePages.find((o) => location === o);
      searchHide = (searchHide) ? true : false;
    }

    this.setState({
      searchHide
    })
  }
  async openMenu() {
    this.setState({
      isOpen: true,
    })
    document.body.classList.add('headerModalOpen');
  }

  async openClose() {

    this.setState({
      isOpen: false,
    })
    document.body.classList.remove('headerModalOpen');
  }

  render() {
    const { siteSettings, borderLess, showMenu, toggleOpen, fixedHeader, becomeHeader, becomeHeaderCss } = this.props;
    // AUTÓNOMO: Usar estado LOCAL isScrolled en lugar de Redux
    const { searchHide, load, mobileSearchOpen, mobileSearchQuery, isMobile, isScrolled } = this.state;
    // Detectar home page incluyendo prefijos de idioma (/es/, /en/, /fr/, /it/, /pt/)
    const pathname = history.location?.pathname || '';
    const isHomePage = pathname === '/' ||
      pathname === '/home' ||
      /^\/(es|en|fr|it|pt)\/?$/.test(pathname) ||
      /^\/(es|en|fr|it|pt)\/home\/?$/.test(pathname);
    let borderClass;
    let location;
    if (borderLess) {
      borderClass = s.rentAllHeaderBorderLess;
    }

    if (history.location) {
      location = history.location.pathname;
    }

    return (
      <header role="banner" className={s.root}>
        <Toaster />
        <LoadingBar />
        <Navbar fluid className={cx(
          s.rentAllHeader,
          'rentAllHeader',
          'hidden-print',
          borderClass,
          s.headerFlexContainer,
          s.paddingBottom18,
          { ['fixedHeader']: location === '/s' || /^\/(es|en|fr|it|pt)\/s/.test(location) },
          { ['homeHeader']: isHomePage },
          { [s.stickyHeader]: isHomePage && isScrolled },
          fixedHeader,
          becomeHeaderCss
        )}
          expanded={showMenu} onToggle={this.handleMenu}>
          <div className={cx(s.container, s.headerFlexBox, { [s.searchHeader]: location === '/s' }, 'containerSearch')}>
            {/* Logo - Left */}
            <Navbar.Header className={cx('logoPadding', !showMenu ? 'normalPosition' : 'fixedPosition', { [s.stickyLogo]: isHomePage && isScrolled })}>
              <Navbar.Brand className={cx(s.homeLogo, 'navBrandRTL')}>
                <Logo link={"/"} className={cx(s.brand, s.brandImg)} />
              </Navbar.Brand>
            </Navbar.Header>

            {/* Publica tu bote - Centrado */}
            {isHomePage && !isScrolled && (
              <div className={cx(s.publishCenterWrapper, 'hidden-xs', 'hidden-sm', 'hidden-md')}>
                <Link to="/why-become-owner" className={s.publishCenterButton}>
                  <FormattedMessage {...messages.listyourCar} />
                </Link>
              </div>
            )}

            {/* Search Bar - Desktop: full bar with slideDown animation */}
            <AnimatePresence>
              {isHomePage && isScrolled && !isMobile && (
                <motion.div
                  className={s.headerSearchCenter}
                  initial={{ opacity: 0, y: -30, scale: 0.95 }}
                  animate={{ opacity: 1, y: 0, scale: 1 }}
                  exit={{ opacity: 0, y: -20, scale: 0.95 }}
                  transition={{
                    duration: 0.35,
                    ease: [0.25, 0.46, 0.45, 0.94],
                    opacity: { duration: 0.25 }
                  }}
                >
                  <HeaderSearchBar isVisible={true} />
                </motion.div>
              )}
            </AnimatePresence>

            {/* Mobile: Search icon button */}
            <AnimatePresence>
              {isHomePage && isScrolled && isMobile && (
                <motion.button
                  className={s.mobileSearchIcon}
                  onClick={this.openMobileSearch}
                  initial={{ opacity: 0, scale: 0.8 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 0.8 }}
                  transition={{ duration: 0.2 }}
                  aria-label="Buscar"
                >
                  <Search size={22} />
                </motion.button>
              )}
            </AnimatePresence>

            {/* Normal search for other pages */}
            {
              !searchHide && !becomeHeader && !isHomePage && <Navbar.Form pullLeft className={('hidden-xs', s.breakPoint, 'headerSearchRTL')}>
                <HeaderLocationSearch />
              </Navbar.Form>
            }

            {/* Navigation buttons - Right */}
            <div onClick={() => this.openMenu()} className={cx({ [s.stickyNav]: isHomePage && isScrolled })}>
              <div className={'closebtnHidden'}>
                <DropDownMenu />
              </div>
            </div>
            <div className={cx(`${(this.state.isOpen === true) ? s.menuOpen : s.menuClose}`, s.mobileMenu, 'homeMobileMenu')}>
              <div className={cx(s.rightMenuClose, 'closebtnHidden')}>
                <div className={s.closeButtonPosition}>
                  <div className={cx(s.closeColor, 'closeColorRTL')} onClick={() => this.openClose()} >
                    ×
                  </div>
                </div>
              </div>

              <div onClick={() => this.openClose()}>
                <Navigation becomeHeader={becomeHeader} />
              </div>
            </div>
          </div>
        </Navbar>

        {/* Mobile Search Modal */}
        <AnimatePresence>
          {mobileSearchOpen && (
            <motion.div
              className={s.mobileSearchOverlay}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.2 }}
            >
              <motion.div
                className={s.mobileSearchModal}
                initial={{ y: -100, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                exit={{ y: -100, opacity: 0 }}
                transition={{ duration: 0.3, ease: [0.4, 0, 0.2, 1] }}
              >
                {/* Close button */}
                <button
                  className={s.mobileSearchClose}
                  onClick={this.closeMobileSearch}
                  aria-label="Cerrar búsqueda"
                >
                  <X size={24} />
                </button>

                {/* Search form */}
                <form onSubmit={this.handleMobileSearch} className={s.mobileSearchForm}>
                  <div className={s.mobileSearchInputWrapper}>
                    <MapPin size={20} className={s.mobileSearchPinIcon} />
                    <input
                      type="text"
                      className={s.mobileSearchInput}
                      value={mobileSearchQuery}
                      onChange={(e) => this.setState({ mobileSearchQuery: e.target.value })}
                      placeholder="¿A dónde quieres navegar?"
                      autoFocus
                    />
                  </div>
                  <motion.button
                    type="submit"
                    className={s.mobileSearchSubmit}
                    whileTap={{ scale: 0.98 }}
                  >
                    <Sparkles size={18} />
                    <span>Buscar con IA</span>
                  </motion.button>
                </form>

                {/* Quick suggestions */}
                <div className={s.mobileSearchSuggestions}>
                  <p className={s.mobileSearchSuggestionsTitle}>Búsquedas populares</p>
                  <div className={s.mobileSearchChips}>
                    {['Miami', 'Cap Cana', 'Cartagena', 'Cancún'].map((place) => (
                      <button
                        key={place}
                        className={s.mobileSearchChip}
                        onClick={() => {
                          this.setState({ mobileSearchQuery: place }, () => {
                            this.handleMobileSearch();
                          });
                        }}
                        type="button"
                      >
                        {place}
                      </button>
                    ))}
                  </div>
                </div>
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>
      </header>
    );
  }
}

const mapState = (state) => ({
  siteSettings: state.siteSettings.data,
  showMenu: state.toggle.showMenu
  // AUTÓNOMO: Ya no dependemos de Redux isSticky, usamos estado local
});

const mapDispatch = {
  toggleOpen,
  toggleClose
};

export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(Header)));